import React, { useContext } from "react"

import classNames from "classnames"

import { Skeleton } from "shared/ui/skeleton/Skeleton"

import { InputContext } from "./Input"

export const InputControlWrapper = React.memo(
  ({
    className,
    children,
    Loader
  }: React.PropsWithoutRef<React.HTMLProps<HTMLDivElement>> & {
    Loader?: React.ReactNode
  }) => {
    const { loading, readonly } = useContext(InputContext)

    if (loading) {
      return Loader ? (
        (Loader as React.JSX.Element)
      ) : (
        <Skeleton
          containerClassName={classNames(
            {
              input__control: !readonly,
              input__value: readonly,
              readonly,
              loading: true
            },
            className
          )}
        />
      )
    }

    if (readonly) {
      return null
    }

    return children as React.JSX.Element
  }
)
